module.exports = __webpack_public_path__ + "images/email/atoz-wordmark.png";